/**
 * Die **Fläche eines Menüs des Rahmens**.
 *
 * Benutzermenü und dessen Untermenü tragen dieselbe, und `FRAME.md` schreibt sie
 * unter „Unit-Menü" mit fünf Werten vor: `--bg-pop`, 1px `--line-c`,
 * `--r-popover`, `--shadow-popover`, 4px Innenabstand. Das Benutzermenü ist dort
 * „sonst wie das Unit-Menü", das Untermenü ebenfalls.
 *
 * **Das ist keine nachgebaute Komponente**, sondern eine Konstante mit fünf
 * Werten aus der Rahmenspezifikation. Der Baustein des Skills, der genau diese
 * Fläche mitbringt, ist `overlays/ContextMenu` — aber nur **mitsamt** seiner
 * Zeilenliste, und beide Menüs hier tragen etwas, das seine Zeilen nicht
 * ausdrücken: eine Kopfzeile mit Name und Rolle, die Fassungszeile am Fuß, eine
 * Zeile mit `check` am Ende. Wo seine Zeilen genügen, steht er darin
 * (Benutzermenü) und legt seine eigene Fläche ab.
 */

import type { CSSProperties } from "react";

export const MENU_SURFACE: CSSProperties = {
  background: "var(--bg-pop)",
  border: "1px solid var(--line-c)",
  borderRadius: "var(--r-popover)",
  boxShadow: "var(--shadow-popover)",
  padding: 4,
};

/**
 * Eine Zeile in einem solchen Menü — die Maße der Vorlage
 * (`reference/AppShell.jsx`, `UnitMenu`), unverändert.
 *
 * Die Hervorhebung unter dem Zeiger steht im CSS (`.erp-menu-item` in
 * `tokens/base.css`) und der Ruhewert als Rückfall daneben: Ein Kennzeichen im
 * Zustand bleibt in einem Menü am sichersten hängen — es schließt sich beim
 * Klick, und das `mouseleave` kommt nie (#87, #97).
 */
export const MENU_ROW: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  width: "100%",
  paddingTop: 7,
  paddingBottom: 7,
  paddingLeft: 10,
  paddingRight: 10,
  border: "none",
  borderRadius: "var(--r-tile)",
  background: "var(--menu-item-hot-bg, transparent)",
  cursor: "pointer",
  fontFamily: "var(--font-sans)",
  fontSize: "var(--fs-13)",
  textAlign: "left",
};
